export enum SupportedContentNode {
  A = "a",
  Blockquote = "blockquote",
  BlockquoteQuote = "blockquote-quote",
  Br = "br",
  Caption = "caption",
  Div = "div",
  Em = "em",
  H1 = "h1",
  H2 = "h2",
  H3 = "h3",
  H4 = "h4",
  H5 = "h5",
  H6 = "h6",
  Iframe = "iframe",
  Image = "img",
  InlineWidget = "inline-widget",
  Li = "li",
  Ol = "ol",
  P = "p",
  S = "s",
  Span = "span",
  Strong = "strong",
  Sub = "sub",
  Sup = "sup",
  Table = "table",
  Tbody = "tbody",
  Td = "td",
  Text = "text",
  Th = "th",
  Thead = "thead",
  Tr = "tr",
  U = "u",
  Ul = "ul",
}
